export const GET_PUBLIC_TICKETS_SUCCESS = 'GET_PUBLIC_TICKETS_SUCCESS';
export const GET_CREATED_TICKETS_SUCCESS = 'GET_CREATED_TICKETS_SUCCESS';
export const GET_ASSIGNED_TICKETS_SUCCESS = 'GET_ASSIGNED_TICKETS_SUCCESS';
export const GET_ALL_TEAM_TICKETS_SUCCESS = 'GET_ALL_TEAM_TICKETS_SUCCESS';
export const GET_CREATED_BY_TEAM_MEMBERS_TICKETS_SUCCESS = 'GET_CREATED_BY_TEAM_MEMBERS_TICKETS_SUCCESS';
export const GET_ALL_TICKETS_SUCCESS = 'GET_ALL_TICKETS_SUCCESS';